import React from "react";

const TwoFAInputs = ({ code, onCodeChange, inputsRef }) => {
  const handleChange = (index, value) => {
    if (!/^[0-9]?$/.test(value)) return;
    onCodeChange(index, value);
    if (value !== "" && index < code.length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (index, e) => {
    if (e.key === "Backspace" && code[index] === "" && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  return (
    <div className="containerInputCode">
      {code.map((value, index) => (
        <input
          key={index}
          ref={(el) => (inputsRef.current[index] = el)}
          className="fa2Input"
          type="text"
          maxLength="1"
          value={value}
          onChange={(e) => handleChange(index, e.target.value)}
          onKeyDown={(e) => handleKeyDown(index, e)}
        />
      ))}
    </div>
  );
};

export default TwoFAInputs;
